import { useEffect, useState } from "react";
import apiService from "../../service/apiService";
import { Form, Card, CardHeader, Row, Col } from "react-bootstrap";
import { Box, Button } from "@mui/material";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";

const AddUser = () => {
  const [userRoleId, setUserRoleId] = useState(0);
  const [roles, setRoles] = useState([]);
  const navigate = useNavigate();
  const [genders, setGenders] = useState([]);
  const [gendid, setGendId] = useState(0);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setpassword] = useState("");
  const [phone, setPHone] = useState("");
  const [age, setAge] = useState(0);
  const [dists, setAllDists] = useState([]);
  const [dist, setDist] = useState(0);
  const [blocks, setBlocks] = useState([]);
  const [block, setBlock] = useState(0);
  const [pgs, setPgs] = useState([]);
  const [selectedPgs, setSelectedPgs] = useState([]);
  const [rolename, setRoleName] = useState("");
  const [selectedBlocks, setSelectedBlocks] = useState([]);
  const [pgsByBlock, setPgsByBlock] = useState({});
  const [aadhaarNumber, setAadhaarNumber] = useState("");

  const fetchRoleId = async () => {
    try {
      const response = await apiService.get('/user-roles/get-all');
      setRoles(response.data);
    } catch (error) {
      console.error('Error fetching seeds:', error);
    }
  };
  const fetchAllDist = async () => {
    try {
      const response = await apiService.get('/districts/get-all');
      setAllDists(response.data);
    } catch (error) {
      console.error('Error fetching seeds:', error);
    }
  };

  const fetchGenders = async () => {
    try {
      const response = await apiService.get(`/master/get-all-gender`);
      setGenders(response.data);
    } catch (error) {
      console.error("Error fetching blocks:", error);
    }
  }

  useEffect(() => {
    fetchRoleId();
    fetchAllDist();
    fetchGenders();
  }, []);


  const fetchBlocks = async () => {
    try {
      const response = await apiService.get(`/master/get-block-by-district/${dist}`);
      setBlocks(response.data.body.blocks);
    } catch (error) {
      console.error("Error fetching blocks:", error);
    }
  }


  const fetchPgs = async () => {
    try {
      const response = await apiService.get(`/master/get-pg-by-block/${block}`);
      setPgs(response.data.body);
    } catch (error) {
      console.error("Error fetching PGs:", error);
    }
  }

  useEffect(() => {
    if (dist > 0) {
      fetchBlocks();
    }
  }, [dist]);

  useEffect(() => {
    if (block > 0) {
      fetchPgs();
    }
  }, [block]);

const handleAdd = async () => {
  const trimmedUserName = username.trim();
  const trimmedEmail = email.trim();
  const trimmedPhone = phone.trim();
  const trimmedPassword = password.trim();

  if (!trimmedUserName || !trimmedEmail || !trimmedPhone || !trimmedPassword || gendid === 0 || userRoleId === 0 || age <= 0) {
    alert("All fields are required and must be valid.");
    return;
  }

  // Map blockId -> selected PG ids
  const blockPgMap = {};
  selectedBlocks.forEach((blkId) => {
    blockPgMap[blkId] = pgsByBlock[blkId]
      ?.filter((pg) => selectedPgs.includes(pg.producerGroupId))
      .map((pg) => pg.producerGroupId) || [];
  });

  const userPayload = {
    userName: trimmedUserName,
    email: trimmedEmail,
    phoneNumber: trimmedPhone,
    password: trimmedPassword,
    genderId: gendid,
    userRoleId: userRoleId,
    age: age,
    districtId: dist,
    aadhaarNumber: aadhaarNumber,
    blocksWithPgs: selectedBlocks.map((blkId) => ({
      blockId: blkId,
      producerGroupIds: blockPgMap[blkId] || []
    }))
  };

  try {
    const response = await apiService.post("/users/create", userPayload);
    if (response.data.status === true) {
      alert("User created successfully!");
      navigate(-1);
    } else {
      alert("Failed to create user. Please try again.");
    }
  } catch (error) {
    console.error("Error creating user:", error);
    alert("An error occurred while creating the user.");
  }
};

  const handleBack = () => {
    navigate(-1); // Go back to the previous page
  };

  const handleCheckboxChange = (pgId) => {
    setSelectedPgs((prevSelected) =>
      prevSelected.includes(pgId)
        ? prevSelected.filter((id) => id !== pgId)
        : [...prevSelected, pgId]
    );
  };
  const handleBlockChange = (blockId) => {
    setSelectedBlocks((prev) =>
      prev.includes(blockId)
        ? prev.filter((id) => id !== blockId)
        : [...prev, blockId]
    );
  };

  useEffect(() => {
    // Fetch PGs for any new blocks
    const fetchPgsForBlock = async (blkId) => {
      try {
        const response = await apiService.get(`/master/get-pg-by-block/${blkId}`);
        setPgsByBlock((prev) => ({
          ...prev,
          [blkId]: response.data.body || []
        }));
      } catch (error) {
        console.error("Error fetching PGs:", error);
      }
    };

    // 1. Add new blocks
    selectedBlocks.forEach((blkId) => {
      if (!pgsByBlock[blkId]) {
        fetchPgsForBlock(blkId);
      }
    });

    // 2. Remove deselected blocks and their PGs
    Object.keys(pgsByBlock).forEach((blkId) => {
      if (!selectedBlocks.includes(Number(blkId))) {
        setPgsByBlock((prev) => {
          const updated = { ...prev };
          delete updated[blkId];
          return updated;
        });

        // Clear PGs from deselected block
        setSelectedPgs((prev) =>
          prev.filter(
            (pgId) => !pgsByBlock[blkId]?.some((pg) => pg.producerGroupId === pgId)
          )
        );
      }
    });
  }, [selectedBlocks]);

  return (
    <Box m="2px">
      <div style={{ maxHeight: "100vh", overflowX: "auto" }}>
        <div className="d-flex justify-content-between align-items-center mx-3">
          <Header title="Add New User" />
          <div className="d-flex">
            <Button
              variant="outlined"
              color="secondary"
              sx={{
                padding: "10px 16px",
                fontSize: "16px",
                fontWeight: "bold",
                textTransform: "none",
                borderRadius: "12px",
                marginRight: "10px",
                border: "1px solid #1976d2",
                color: "#1976d2",
                "&:hover": {
                  background: "#e3f2fd",
                },
              }}
              onClick={handleBack}
            >
              Back
            </Button>

            <Button
              variant="contained"
              color="primary"
              sx={{
                padding: "10px 16px",
                fontSize: "16px",
                fontWeight: "bold",
                textTransform: "none",
                borderRadius: "12px",
                background: "linear-gradient(90deg, #1976d2, #42a5f5)",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
                "&:hover": {
                  background: "linear-gradient(90deg, #1565c0, #2196f3)",
                },
              }}
              onClick={handleAdd}
            >
              Save
            </Button>
          </div>
        </div>
        <Card className="mx-5 mb-2">
          <CardHeader>
            <div className="d-flex justify-content-between">
              <h6 style={{ fontWeight: "bold" }}>Enter User Details</h6>
            </div>
          </CardHeader>
          <Form className="p-4">
            <Row>
              <Col xs={12} md={6}>
                <Col md={12} className="mb-3">
                  <Form.Group controlId="username">
                    <Form.Label style={{ fontWeight: "bold" }}>User Name</Form.Label>
                    <Form.Control type="text" placeholder="Enter user name" onChange={(e) => { setUsername(e.target.value) }} />
                  </Form.Group>
                </Col>


                <Col md={12} className="mb-3">
                  <Form.Group controlId="email">
                    <Form.Label style={{ fontWeight: "bold" }}>Email</Form.Label>
                    <Form.Control type="text" placeholder="Enter email" onChange={(e) => { setEmail(e.target.value) }} />
                  </Form.Group>
                </Col>
                <Col md={12} className="mb-3">
                  <Form.Group controlId="phone">
                    <Form.Label style={{ fontWeight: "bold" }}>Phone Number</Form.Label>
                    <Form.Control type="text" placeholder="Enter phone number" onChange={(e) => { setPHone(e.target.value) }} />
                  </Form.Group>
                </Col>


                <Col md={12} className="mb-3">
                  <Form.Group controlId="description">
                    <Form.Label style={{ fontWeight: "bold" }}>Age</Form.Label>
                    <Form.Control type="text" placeholder="Enter Age" onChange={(e) => { setAge(Number(e.target.value)) }} />
                  </Form.Group>
                </Col>
              </Col>
              <Col xs={12} md={6}>
                <Col md={12} className="mb-3">
                  <Form.Group controlId="description">
                    <Form.Label style={{ fontWeight: "bold" }}>Gender</Form.Label>
                    <Form.Control
                      as="select"
                      value={gendid}
                      onChange={(e) => { setGendId(Number(e.target.value)); }}
                      className="form-select form-select-md"
                    >
                      <option value={0} disabled >Select</option>
                      {genders.map((gen) => (
                        <option key={gen.genderId} value={gen.genderId}>
                          {gen.gender}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={12} className="mb-3">
                  <Form.Group controlId="password">
                    <Form.Label style={{ fontWeight: "bold" }}>Enter Password</Form.Label>
                    <Form.Control type="text" placeholder="Enter password" onChange={(e) => { setpassword(e.target.value) }} />
                  </Form.Group>
                </Col>


                <Col md={12} className="mb-3">
                  <Form.Group controlId="description">
                    <Form.Label style={{ fontWeight: "bold" }}>Confirm Password</Form.Label>
                    <Form.Control type="text" placeholder="Enter confirm password" />
                  </Form.Group>
                </Col>



                {/* For aadhar enter  */}
                <Col md={12} className="mb-3">
                  <Form.Group controlId="aadhaarNumber">
                    <Form.Label style={{ fontWeight: "bold" }}>Aadhar Number</Form.Label>
                    <Form.Control type="text" placeholder="Enter Aadhar Number" onChange={(e) => { setAadhaarNumber(e.target.value) }} />
                  </Form.Group>

                </Col>

              </Col>
            </Row>
          </Form>
        </Card>
        <Card className="mx-5 mb-2">
          <CardHeader>
            <div className="d-flex justify-content-between">
              <h6 style={{ fontWeight: "bold" }}>Enter Role Details</h6>
            </div>
          </CardHeader>
          <Form className="p-4">
            <Row>
              <Col xs={12} md={6}>
                <Col md={12} className="mb-3">
                  <Form.Group controlId="roleName">
                    <Form.Label style={{ fontWeight: "bold" }}>Select User Role</Form.Label>
                    <Form.Control
                      as="select"
                      value={userRoleId}
                      onChange={(e) => {
                        const selectedRoleId = Number(e.target.value);
                        setUserRoleId(selectedRoleId);
                        const selectedRole = roles.find((role) => role.userRoleId === selectedRoleId);
                        setRoleName(selectedRole?.roleName || "");
                        setDist(0);
                        setBlock(0);
                        setPgs([]);
                        setSelectedPgs([]);
                        setPgsByBlock({});
                        setSelectedBlocks([]);
                      }}
                      className="form-select form-select-md"
                    >
                      <option value={0} disabled>
                        Select Role
                      </option>
                      {roles.map((role) => (
                        <option key={role.userRoleId} value={role.userRoleId}>
                          {role.roleName}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Col>
              <Col xs={12} md={6}>

                <Col md={12} className="mb-3">
                  <Form.Group controlId="dist">
                    <Form.Label style={{ fontWeight: "bold" }}>Select Dist</Form.Label>
                    <Form.Control
                      as="select"
                      value={dist}
                      onChange={(e) => { setDist(Number(e.target.value)); setBlock(0); setPgs([]); setSelectedPgs([]); }}
                      className="form-select form-select-md"
                    >
                      <option value={0} disabled>
                        Select Dist
                      </option>
                      {dists.map((dst) => (
                        <option key={dst.districtId} value={dst.districtId}>
                          {dst.districtName}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                {/* {((rolename === "Block Coordinator" || rolename === "Producer Group Facilitator" ) && dist>0 ) && (

                <Col md={12} className="mb-3">
                  <Form.Group controlId="block">
                    <Form.Label style={{ fontWeight: "bold" }}>Select Block</Form.Label>
                    <Form.Control
                      as="select"
                      value={block}
                      onChange={(e) => {setBlock(Number(e.target.value)); setSelectedPgs([]); setPgs([]); }}
                      className="form-select"
                    >
                      <option value={0} disabled>Select Block</option>
                      {blocks.map((blk) => (
                        <option key={blk.blockId} value={blk.blockId}>{blk.blockName}</option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                )} */}
                {(rolename === "Block Coordinator" || rolename === "Producer Group Facilitator") && dist > 0 && (
                  <Col md={12} className="mb-3">
                    <Form.Group controlId="block">
                      <Form.Label style={{ fontWeight: "bold" }}>Select Blocks</Form.Label>
                      <div className="p-2 border rounded" style={{ maxHeight: "200px", overflowY: "scroll" }}>
                        {blocks.map((blk) => (
                          <Form.Check
                            key={blk.blockId}
                            type="checkbox"
                            id={`block-checkbox-${blk.blockId}`}
                            label={blk.blockName}
                            value={blk.blockId}
                            checked={selectedBlocks.includes(blk.blockId)}
                            onChange={() => handleBlockChange(blk.blockId)}
                            className="mb-2"
                          />
                        ))}
                      </div>
                    </Form.Group>
                  </Col>
                )}
                {/* {rolename === "Producer Group Facilitator" && block !== 0 && (
                  <Col md={12} className="mb-3">
                  <Form.Group controlId="pgs">
                    <Form.Label style={{ fontWeight: "bold" }}>Select PGs</Form.Label>
                    <div className="p-2 border rounded" style={{
                      maxHeight: pgs.length > 8 ? "200px" : "auto", 
                      overflowY: pgs.length > 8 ? "scroll" : "visible", 
                    }}>
                      {pgs.map((pg) => (
                        <Form.Check
                          key={pg.producerGroupId}
                          type="checkbox"
                          id={`pg-checkbox-${pg.producerGroupId}`}
                          label={`${pg.pgName} - ${pg.pgCode}`}
                          value={pg.producerGroupId}
                          checked={selectedPgs.includes(pg.producerGroupId)}
                          onChange={() => handleCheckboxChange(pg.producerGroupId)}
                          className="mb-2"
                        />
                      ))}
                    </div>
                  </Form.Group>
                </Col>
                )} */}
                {rolename === "Producer Group Facilitator" && selectedBlocks.length > 0 && (
                  <Col md={12} className="mb-3">
                    <Form.Group controlId="pgs">
                      <Form.Label style={{ fontWeight: "bold" }}>Select PGs</Form.Label>
                      <div className="p-2 border rounded" style={{ maxHeight: "300px", overflowY: "scroll" }}>
                        {selectedBlocks.map((blkId) => {
                          const blk = blocks.find((b) => b.blockId === blkId);
                          return (
                            <div key={blkId} className="mb-3">
                              <h6 style={{ fontWeight: "bold", color: "#1976d2" }}>{blk?.blockName}</h6>
                              {pgsByBlock[blkId]?.map((pg) => (
                                <Form.Check
                                  key={pg.producerGroupId}
                                  type="checkbox"
                                  id={`pg-checkbox-${pg.producerGroupId}`}
                                  label={`${pg.pgName} - ${pg.pgCode}`}
                                  value={pg.producerGroupId}
                                  checked={selectedPgs.includes(pg.producerGroupId)}
                                  onChange={() => handleCheckboxChange(pg.producerGroupId)}
                                  className="ms-3 mb-2"
                                />
                              ))}
                            </div>
                          );
                        })}
                      </div>
                    </Form.Group>
                  </Col>
                )}
              </Col>
            </Row>
          </Form>
        </Card>
      </div>
    </Box>
  )
}

export default AddUser